import styled from 'styled-components'

import background from '../../assets/img/background-login.png'

export const Wrapper = styled.main`
  display: flex;
  align-items: center;
  width: 100%;
`

export const SideLeft = styled.div`
  width: 100%;
  height: 100vh;
  color: #fff;
  background: url(${background});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`

export const SideRight = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  img {
    margin: 50px;
  }

  h3 {
    margin-bottom: 15px;
  }

  .link {
    margin-bottom: 20px;
    font-size: 12px;
  }

  .signin {
    margin-top: 35px;
  }
`

export const WrapperMessage = styled.div`
  .message {
    font-weight: bold;
    font-size: 52px;
    line-height: 120%;
    letter-spacing: -0.025em;
  }

  .describe {
    font-size: 18px;
    margin-top: 12px;
  }
`

export const Background = styled.div`
  background: rgba(3, 5, 23, 0.85);
  width: 100%;
  height: 100vh;
  justify-content: space-between;
  display: flex;
  align-items: baseline;
  padding: 50px;
  flex-direction: column;

  .footer-message {
    text-align: center;
    font-size: 12px;
    width: 100%;
  }
`
